var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ELYXToggleButton",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"ELYXToggleButton__background",class:_vm.isEnabled ? 'ELYXToggleButton__background--active' : ''},[_c('div',{staticClass:"ELYXToggleButton__circle",class:_vm.isEnabled ? 'ELYXToggleButton__circle--active ' : ''})])])
}
var staticRenderFns = []

export { render, staticRenderFns }